import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import UserInfo from '@ifeng/ui_pc_userInfo';
import Search from '@ifeng/ui_pc_search';
import Jubao from '../../components/jubao';
import Logo from './logo';
import Donate from './donate';
import { rel } from '../../../utils/rel';

/**
 * 定义 Header 组件
 */
class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { logo, danate, search, jubaoData },
        } = this.props;

        const SearchComp = errorBoundary(Search);

        return (
            <div id="main_nav" className={styles.header}>
                <div className={styles.header_l}>
                    <Chip id="50055" type="struct" title="logo" groupName="顶部" content={logo}>
                        <Logo />
                    </Chip>
                </div>
                <div className={styles.header_r}>
                    <div className={styles.box_top}>
                        <div className={styles.donate_box}>
                            <Chip id="50088" type="struct" title="凤凰公益" groupName="顶部" content={danate}>
                                <Donate />
                            </Chip>
                        </div>
                        <div className={styles.jb_box}>
                            <Chip id="50138" type="struct" title="举报信息" groupName="顶部" content={jubaoData}>
                                <Jubao />
                            </Chip>
                        </div>
                    </div>
                    <div className={styles.login}>
                        <div className={styles.user}>
                            <NoSSR>
                                <UserInfo iconShow option={['login', 'register']} />
                            </NoSSR>
                        </div>
                        <div className={styles.line} />
                        <div className={styles.search}>
                            <Chip id="20005" type="struct" title="搜索" groupName="顶部" content={search}>
                                <SearchComp expand />
                            </Chip>
                        </div>
                        <div className={styles.line} />
                        <div className={styles.ifeng}>
                            <a href="//a.ifeng.com/?from=home" target="_blank" rel={rel}>
                                手机看新闻
                            </a>
                        </div>
                        <div className={styles.line} />
                        <div className={styles.phtv}>
                            <a
                                href="http://phtv.ifeng.com/english.shtml"
                                target="_blank"
                                rel={rel}
                                sign-trs-href="http://phtv.ifeng.com/english.shtml">
                                PHOENIX TV
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
